import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { func, node, string } from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../../actions/bikesManagementActions";
import { BikeLogisticsStatus } from "../../models/BikeModel";

const BikeLogisticsStatusDialog = ({
  bikeId,
  children,
  currentStatus,
  onBeforeShow,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(
    currentStatus || BikeLogisticsStatus.none.value,
  );

  const handleClick = () => {
    if (onBeforeShow) onBeforeShow();
    setStatus(currentStatus || BikeLogisticsStatus.none.value);
    setOpen(true);
  };

  const handleCancel = () => setOpen(false);
  const handleSave = () => {
    setSubmitting(true);
    dispatch(actions.setLogisticsStatus(bikeId, status)).then((saved) => {
      setSubmitting(false);
      if (saved) setOpen(false);
    });
  };

  return (
    <>
      {React.cloneElement(children, { onClick: handleClick })}
      <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>Status logistyczny roweru</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Wybierz aktualny status</FormLabel>
            <RadioGroup
              name="bikeLogisticsStatus"
              value={status}
              onChange={(event) => setStatus(event.target.value)}
            >
              {Object.values(BikeLogisticsStatus).map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio color="primary" />}
                  label={option.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} disabled={submitting}>
            Anuluj
          </Button>
          <Button
            onClick={handleSave}
            disabled={submitting || status === currentStatus}
            variant="contained"
            color="primary"
          >
            Zapisz
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

BikeLogisticsStatusDialog.propTypes = {
  bikeId: string.isRequired,
  children: node.isRequired,
  currentStatus: string,
  onBeforeShow: func,
};

export default BikeLogisticsStatusDialog;
